import AdaptiveStore from 'ember-simple-auth/session-stores/adaptive';

// this is a dummy session store that is used to test the session store
// actual service is located in the `hcp/app/session-stores` package
export default class SessionStore extends AdaptiveStore {}
